// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__r-wGU","Label":"Input_Label__2-2vi","InputElement":"Input_InputElement__1axGM","Invalid":"Input_Invalid__3nbbJ"};